import { Component, OnInit, inject } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { PrimeNGConfig } from "primeng/api"
import { map } from "rxjs"
import { OrderService } from "./services/order.service"

@Component({
  selector: "ow-root",
  templateUrl: "./app.component.html"
})
export class AppComponent implements OnInit {
  private config = inject(PrimeNGConfig)
  private route = inject(ActivatedRoute)
  private orderService = inject(OrderService)

  ngOnInit() {
    this.setTranslations()
    this.watchQueryParams()
  }

  private setTranslations(): void {
    this.config.setTranslation({
      startsWith: "Beginnt mit",
      contains: "Enthält",
      notContains: "Enthält nicht",
      endsWith: "Endet mit",
      equals: "Ist gleich",
      notEquals: "Ist ungleich",
      noFilter: "Kein Filter",
      lt: "Kleiner als",
      lte: "Kleiner oder gleich",
      gt: "Größer als",
      gte: "Größer oder gleich",
      dateIs: "Datum ist",
      dateIsNot: "Datum ist nicht",
      dateBefore: "Datum ist vor",
      dateAfter: "Datum ist nach",
      clear: "Löschen",
      apply: "Übernehmen",
      matchAll: "Passt auf alle",
      matchAny: "Passt auf einige",
      addRule: "Regel hinzufügen",
      removeRule: "Regel entfernen",
      accept: "Ja",
      reject: "Nein",
      choose: "Auswählen",
      upload: "Hochladen",
      cancel: "Abbrechen",
      dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
      dayNamesShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
      dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      monthNames: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
      today: "Heute",
      weekHeader: "KW",
      firstDayOfWeek: 1,
      dateFormat: "dd.mm.yy",
      weak: "Schwach",
      medium: "Mittel",
      strong: "Stark",
      passwordPrompt: "Passwort eingeben",
      emptyFilterMessage: "Keine Ergebnisse gefunden",
      emptyMessage: "Keine Einträge gefunden"
    })
  }

  private watchQueryParams(): void {
    this.route.queryParamMap.subscribe((queryParamMap) => {
      const salescode = queryParamMap.get("salescode")
      if (salescode) {
        this.orderService.setSalescode(salescode)
      }
    })
  }

}
